'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var numeral = require('numeral');

var CurrencyHelper = function () {
  function CurrencyHelper() {
    _classCallCheck(this, CurrencyHelper);
  }

  _createClass(CurrencyHelper, [{
    key: 'formatCurrency',
    value: function formatCurrency(num) {
      return numeral(num).format('$0,0.00');
    }
  }, {
    key: 'formatCurrencyJP',
    value: function formatCurrencyJP(num) {
      return numeral(num).format('$0,0');
    }
  }, {
    key: 'parseCurrency',
    value: function parseCurrency(v) {
      return numeral(v).value();
    }
  }]);

  return CurrencyHelper;
}();

var currencyHelper = new CurrencyHelper();

exports.default = currencyHelper;


//////////////////
// WEBPACK FOOTER
// ../component-common/dist/helpers/CurrencyHelper.js
// module id = 869
// module chunks = 0